export default "__VITE_ASSET__DmdKMmmr__"